export function isConfig(f) {
    // Naive check but works well
    return f.getConfig === undefined;
}
